import React from 'react'

import styled from '@emotion/styled'

import { Grid, Text, typography } from '@cash-design-system/react'
import { DisclosureBlockerLineItem } from '@cash-web/protos/squareup/franklin/blockers/disclosure_blocker.pb'

import { lineItemsTextTokenizer } from '../DisclaimerTextTokenizer/DisclaimerTextTokenizer'

export interface LineItemsProps {
  compact?: boolean
  lineItems: DisclosureBlockerLineItem[]
  typography?: keyof typeof typography
}

const DescriptionTitle = styled.dt<{ shouldAddSpacing: boolean }>`
  margin-bottom: ${props => (props.shouldAddSpacing ? props.theme.spacing.m : 0)};
`

const DescriptionDetail = styled.dd`
  text-align: right;
`

export const LineItems: React.FC<LineItemsProps> = ({
  compact = false,
  lineItems,
  typography = 'titleBarPageTitle',
}) => {
  const isLargeLineItem = typography === 'titleBarPageTitle'
  return (
    <Text color="textStandard" typography={typography}>
      <Grid gridTemplateColumns="1fr auto" columnGap="m" rowGap={isLargeLineItem ? 'm' : 'xs'} as="dl">
        {lineItems.map((lineItem, index) => {
          const titleText = lineItemsTextTokenizer([lineItem.title_text])
          const detailText = lineItemsTextTokenizer([lineItem.detail_text])
          const shouldAddSpacing = !compact && !isLargeLineItem && (lineItem.detail_text ?? '').trim().length !== 0

          return (
            <React.Fragment key={`title-${index}`}>
              <DescriptionTitle key={`title-${index}`} shouldAddSpacing={shouldAddSpacing}>
                {titleText}
              </DescriptionTitle>
              <DescriptionDetail key={`detail-${index}`}>{detailText}</DescriptionDetail>
            </React.Fragment>
          )
        })}
      </Grid>
    </Text>
  )
}

export default LineItems
